import axioPath from "api/ptPlusApiBaseUrl";
import axioPathPt from 'api/axioPath';
import { showAppLoader, hideAppLoader } from '../app';

export const createOrder = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.post("/ptms/pickup/create_pickup_order", data, {
    headers: {
      Authorization: `${token}`,
      UserType: "internal",
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return { error: false, data: response.data };
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const fetchEditOrderApi = (ordRefNo, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.get(`/ptms/pickup/order/${ordRefNo}`, {
    headers: {
      Authorization: `${token}`,
      UserType: "internal",
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return { error: false, data: response.data };
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const fetchPickupRequestTenderDataApi = (ordRefNo, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.get(`/ptms/buyback/pickup_order_details/${ordRefNo}`, {
    headers: {
      Authorization: `${token}`,
      UserType: "internal",
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return { error: false, data: response.data };
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};

export const updateOrder = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.post("/ptms/pickup/update", data, {
    headers: {
      Authorization: `${token}`,
      UserType: "internal",
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return { error: false, data: response.data };
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const deleteOrder = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.post(`/ptms/pickup/delete`, data, {
    headers: {
      Authorization: `${token}`,
      UserType: "internal",
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return { error: false, data: response.data };
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const requestTendorApiCall = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPathPt.post("/order/pickup/request_tender", data, {
    headers: {
      Authorization: `${token}`,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return { error: false, data: response.data };
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};

export const fetchDeliveryRequestTenderDataApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.post(`/ptms/delivery_pricing/tendor_checkout_details`, data, {
    headers: {
      Authorization: `${token}`,
      UserType: "internal",
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return { error: false, data: response.data };
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};

export const requestDeliveryTendorApiCall = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPathPt.post("/order/delivery/request_tender", data, {
    headers: {
      Authorization: `${token}`,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return { error: false, data: response.data };
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};